<script>
import PercentageBarComponent from '../PercentageBar';

/**
 * This is a wrapper around the PercentageBar component which provides the interface
 * that formatters are expected to have.
 */
export default {
  components: { PercentageBarComponent },
  props:      {
    value: {
      type:    String,
      default: ''
    },
    row: {
      type:    Object,
      default: () => {}
    },
    col: {
      type:    Object,
      default: () => {}
    }
  },
  computed: {
    percentage() {
      return Number.parseFloat(this.value);
    }
  }
};
</script>

<template>
  <p v-if="!value || value === '0' || isNaN(value)">
    {{ t('generic.na') }}
  </p>
  <PercentageBarComponent
    v-else
    :modelValue="percentage"
    :show-percentage="true"
  />
</template>

<style lang="scss" scoped>
.percentage-bar {
  width: 108px;
  max-width: 100%;

  :deep(.percentage-value) {
    flex: 0 0 36px;
    text-align: right;
    font-size: 11px;
  }
}
p { margin: 0; color: var(--muted, var(--body-text)); font-size: 12px; }
</style>
